import { ReferenceFeatureEnum, TrimCardStatusEnum } from '@project-management-system/shared-models';
import { Entity, PrimaryGeneratedColumn, Column, CreateDateColumn } from 'typeorm'

@Entity('image_upload')
export class WfxImageUploadEntity {

    @PrimaryGeneratedColumn('increment', {
        name: 'id',
    })
    id: number


    @Column('varchar', {
        nullable: true,
        length: 300,
        name: 'buyer'
    })
    buyer: string;

    @Column('enum', {
        nullable: true,
        name: 'reference_feature',
        enum: ReferenceFeatureEnum
    })
    referenceFeature: ReferenceFeatureEnum;

    @Column('int', {
        nullable: false,
        name: 'reference_feature_id'
    })
    referenceFeatureId: number;

    @Column('text', {
        nullable: true,
        name: 'file_path'
    })
    filePath: Text;

    @Column('varchar', {
        nullable: true,
        length: 250,
        name: 'file_name'
    })
    fileName: string;

    @Column('varchar', {
        nullable: true,
        length: 250,
        name: 'original_name'
    })
    originalName: string;

    @Column('varchar', {
        nullable: true,
        length: 250,
        name: 'modified_original_name'
    })
    modifiedOriginalName: string;

    @Column("boolean", {
        nullable: true,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;

    @Column('enum', {
        nullable: true,
        name: 'status',
        enum: TrimCardStatusEnum
    })
    status: TrimCardStatusEnum;

    @Column('varchar', {
        nullable: true,
        length: 300,
        name: 'material_code'
    })
    materialCode: string;

}